import ActivatePromo from './ActivatePromo'

export default ActivatePromo
